export default __webpack_public_path__ + "static/media/ecom2.3066c9d7.jpeg";